import db from "../../js/db";
import * as api from "../../js/api";
import * as types from "../mutations-types";
import Constants from "../../js/constants";
import { vuexfireMutations } from "vuexfire";

const state = {
  all: {},
  original: {},
  custom: {},
  conf: {},
  anniStats: {},
};

// getters
const getters = {
  // calciatori: state => state.all,
  calciatori: (state, getters, rootState, rootGetters) =>
    getCalciatori(state, getters, rootState, rootGetters),
  calciatoriOriginal: (state) => state.original,
  calciatoriCustom: (state) => state.custom,
  listoneConf: (state) => state.conf,
  anniStats: (state, getters, rootState, rootGetters) =>
    getAnniStats(state, getters, rootState, rootGetters),
};

function getCalciatori(state, getters, rootState, rootGetters) {
  if (
    rootGetters.asta_info.settings.tipo_ruoli == Constants.TIPO_RUOLI.MANTRA
  ) {
    // nel mantra non è detto che siano settati i mantra_ids di tutti
    const keysToRemove = _.keys(
      _.pickBy(state.all, (calciatore) => !calciatore.mantra_ids)
    );
    const calciatoriMantra = _.omit(state.all, keysToRemove);
    return calciatoriMantra;
  } else {
    return state.all;
  }
}

function getAnniStats(state, getters, rootState, rootGetters) {
  let output = [];
  let calciatore = Object.values(state.original)[0];
  if (calciatore && calciatore.stats) {
    output = Object.keys(calciatore.stats);
  }
  return output;
}

// actions
const actions = {
  setCalciatoriOriginal({ commit }) {
    return db.getCalciatoriOriginal().then((calciatori) => {
      commit(types.CALCIATORI_ORIGINAL, calciatori);
    });
  },

  setMainStatus({ commit }) {
    return api.getMainStatus().then((msCalciatori) => {
      if (msCalciatori && _.size(msCalciatori) > 0) {
        commit(types.CALCIATORI_MAIN_STATUS, msCalciatori);
      }
    });
  },

  setListoneConf({ commit }) {
    return db.getListoneConf().then((listoneConf) => {
      commit(types.LISTONE_CONF, listoneConf);
    });
  },

  fetchCalciatoriCustom() {
    db.fetchCalciatoriCustom();
  },
};
// mutations
const mutations = {
  [types.CALCIATORI_ORIGINAL](state, calciatori) {
    state.original = calciatori;
    state.all = _.merge({}, state.all, calciatori);
  },
  [types.CALCIATORI_CUSTOM](state, custom) {
    state.custom = custom;
    state.all = _.merge({}, state.all, custom);
  },
  [types.CALCIATORI_MAIN_STATUS](state, msCalciatori) {
    state.all = _.merge({}, state.all, _.pick(msCalciatori, _.keys(state.all)));
  },
  [types.CALCIATORI_CLR](state) {
    state.original = {};
    state.custom = {};
    state.all = {};
  },
  [types.LISTONE_CONF](state, listoneConf) {
    state.conf = listoneConf;
  },
  ...vuexfireMutations,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
